import { captureEvent } from "../analytics-client";
import { DISCOVERY_ATTRIBUTION_KEY, DISCOVERY_ATTRIBUTION_TTL, updateDiscoveryAttribution, type DiscoveryAttribution } from "./attribution";

let attribution: DiscoveryAttribution | null = null;
let observedPage = "";

export function captureDiscoveryEvent(event: string, properties: Record<string, string | number | boolean | null | undefined> = {}, nativeTool = false) {
  if (typeof window === "undefined") return;
  // Re-evaluate landing signals only on navigation, so an old referrer cannot
  // reset attribution after a real tool invocation or extend its lifetime.
  if (observedPage !== window.location.href || nativeTool) {
    let storage: Storage | null = null;
    try { storage = window.sessionStorage; } catch { /* Private browsing can disable storage. */ }
    const signalUrl = new URL(window.location.href);
    if (observedPage && !nativeTool) {
      const previous = new URL(observedPage);
      // Calendar filters may retain a landing tag while changing the query.
      // An unchanged tag must not overwrite newer native-tool evidence or
      // restart its attribution window on each filter/navigation update.
      for (const key of ["discovery_source", "utm_source"]) {
        if (signalUrl.searchParams.get(key) === previous.searchParams.get(key)) signalUrl.searchParams.delete(key);
      }
    }
    attribution = updateDiscoveryAttribution(storage, signalUrl, observedPage ? "" : document.referrer, nativeTool);
    observedPage = window.location.href;
  } else if (attribution && Date.now() - attribution.started_at >= DISCOVERY_ATTRIBUTION_TTL) {
    attribution = null;
    try { window.sessionStorage.removeItem(DISCOVERY_ATTRIBUTION_KEY); } catch { /* Optional storage. */ }
  }
  try {
    captureEvent(event, {
      ...properties, discovery_source: attribution?.source ?? "unattributed",
      discovery_source_evidence: attribution?.evidence ?? "none",
      discovery_started_at: attribution?.started_at ?? null,
    });
  } catch { /* Optional analytics must not interrupt tools, playback or navigation. */ }
}
